'use client'

import CareboardingIcon from '@/svgs/CareboardingIcon'
import CheckmarkIcon from '@/svgs/Checkmark'
import RightArrowIcon from '@/svgs/RightArrow'
import RobotmakerIcon from '@/svgs/RobotmakerIcon'
import PortfolioItem from './PortfolioItem'
import { useState } from 'react'
import WebPortfolioItem from './WebPortfolioItem'

export const mobilePortfolioItems = [
   {
      imageSrc: '/assets/image/slider3.png',
      title: 'Magic Shoes',
      description:
         'Magic Shoes is a Move-to-Earn fitness app that rewards walking, running, or cycling with tokens. Users equip NFT Magic Shoes—each with unique traits and upgrade options—to track distance, time, and calories. With social features, goal tracking, and blockchain-based rewards, the app gamifies workouts, making fitness fun, competitive, and rewarding for all activity levels.',
      businessNeeds: [
         'A platform that merges physical fitness with digital rewards.',
         'Engaging and motivating workout experiences for users.',
         'Tracking and analytics for workout performance.',
         'A marketplace for unique digital assets (NFTs).',
         'Social features to compete and interact with other users.',
         'Scalable technology to support a growing user base.',
         'Integration with blockchain for token earnings and NFT transactions.',
         'User-friendly design for ease of use across all fitness levels.',
      ],
      learnMoreLink: '/portfolio/magic-shoes',
      imageFirst: true, // Image comes first
   },
   {
      imageSrc: '/assets/image/slider2.png',
      title: 'Daily Motivational Quotes App',
      description:
         'Beyond just delivering words of encouragement, Enliven offers a truly interactive experience with features like customizable notification timings, effortless social sharing, and personalized content options tailored to individual preferences. The app’s extensive quote library, combined with an engaging and supportive community, fosters a sense of connection and shared inspiration.',
      businessNeeds: [
         'Deliver daily motivational quotes to inspire and uplift users.',
         'Provide guided mindfulness and meditation techniques.',
         'Offer a seamless and intuitive user experience.',
         'Enable customizable notifications for personalized motivation.',
         'Integrate a diverse quote library featuring thought leaders and philosophers.',
         'Encourage user interaction through a supportive community.',
         'Allow easy social media sharing for spreading inspiration.',
         'Ensure a balance between free content and premium features.',
      ],
      learnMoreLink: '/portfolio/motivation-quotes',
      imageFirst: false, // Content comes first
   },
   {
      imageSrc: '/assets/image/slider1.png',
      title: 'Wedding Planner: Easy Weddings',
      description:
         "Easy Wedding transforms the daunting task of wedding planning into an enjoyable experience. Leveraging the trust of 80% of Australian couples, our comprehensive planner and directory bring confidence and control into your hands. From organizing tasks to browsing real weddings for inspiration, we've got you covered.",
      businessNeeds: [
         'Streamline wedding planning processes.',
         'Offer a comprehensive budget management tool.',
         'Simplify guest list creation and management.',
         'Provide a centralized platform for wedding milestones.',
         'Create an accessible wedding vendor directory.',
         'Facilitate user reviews for vendor services.',
         'Incorporate a wedding style quiz for personalization.',
         'Showcase real weddings for inspiration and ideas.',
      ],
      learnMoreLink: '/portfolio/wedding-planner',
      imageFirst: true, // Image comes first
   },
   {
      imageSrc: '/assets/image/slider4.png',
      title: 'Tracker: Running, Step, Water',
      description:
         "Introducing Tracker: Running, Step, Water – a comprehensive mobile application designed by Benzatine Infotech to revolutionize your fitness journey. Whether you're a seasoned runner or just getting started, this app offers an all-in-one solution to monitor and enhance your running performance, step count, and hydration levels with precision and ease.",
      businessNeeds: [
         'Real-time tracking of running routes via GPS.',
         'Comprehensive analysis of running performance.',
         'Daily step count monitoring with a pedometer.',
         'Hydration level tracking for optimal health.',
         'Goal setting for heart health and running distance.',
         'Sharing capabilities for routes and achievements.',
         'Detailed records of fitness activities.',
         'Progress tracking over time for motivation.',
      ],
      learnMoreLink: '/portfolio/tracker',
      imageFirst: false, // Content comes first
   },
   {
      imageSrc: '/assets/image/slider5.png',
      title: 'Travel Expense Dairy',
      description:
         'Travel Expense Diary is an innovative and user-friendly travel budgeting solution that simplifies financial management on the go. With its intuitive tracking system, the app helps users log expenses in real-time, categorize costs, and generate insightful reports, ensuring complete control over travel finances. Whether planning a business trip, an international adventure, or a weekend getaway.',
      businessNeeds: [
         'Provide an easy-to-use travel expense tracking solution.',
         'Enable real-time logging and categorization of expenses.',
         'Offer multi-currency support for international travelers.',
         'Generate insightful reports for budget planning and financial analysis.',
         'Allow cloud-based backup and synchronization across devices.',
         'Enable users to set budget limits and receive overspending alerts.',
         'Ensure a clean and intuitive interface for effortless financial management.',
         'Balance free and premium features for an optimal user experience.',
      ],
      learnMoreLink: '/portfolio/travel-expense',
      imageFirst: true, // Image comes first
   },
   {
      imageSrc: '/assets/image/slider6.png',
      title: 'QR Code Scanner & Barcode Read',
      description:
         "QR Scanner Revolution simplifies the process of scanning QR codes and barcodes, supporting all formats including Wi-Fi, contacts, URLs, and more. Features like automatic browser opening for links, instant email access, and VCard contact addition enhance its utility. The app's capability to generate QR codes for a variety of content and its commitment to privacy.",
      businessNeeds: [
         'Seamless integration with device cameras for instant scanning.',
         'Comprehensive format support for universal application.',
         'User-friendly interface for effortless operation.',
         'Privacy assurance to foster trust.',
         'High-speed decoding to enhance user experience.',
         'Scan history and favorites for easy access.',
         'Flashlight support for low-light scanning.',
         'Automatic operation mode to streamline processes.',
      ],
      learnMoreLink: '/portfolio/qr-scanner',
      imageFirst: false, // Content comes first
   },
   {
      imageSrc: '/assets/image/slider7.png',
      title: 'Home Workout For Men Women',
      description:
         'The Home Workout for Men & Women app is a comprehensive fitness solution designed to make working out simple, accessible, and effective. With a wide range of scientifically proven bodyweight exercises, users can train different muscle groups without needing gym equipment. The app features step-by-step guidance, progress tracking.',
      businessNeeds: [
         'Provide structured, effective home workout routines for all fitness levels.',
         'Offer no-equipment exercises for a hassle-free fitness experience.',
         'Deliver AI-powered personalized workout plans based on user goals.',
         'Integrate progress tracking and workout history for motivation.',
         'Ensure a seamless and intuitive user interface for easy navigation.',
         'Include smart workout reminders to maintain consistency.',
         'Support video and animated workout guides for proper form and technique.',
         'Offer a balance between free and premium workout plans.',
      ],
      learnMoreLink: '/portfolio/workout',
      imageFirst: true, // Image comes first
   },
]

const webPortfolioItems = [
   {
      href: '/portfolio/case-studies/care-boarding',
      title: 'Care Boarding',
      description: `Care boarding  stands as a purpose-built, next-generation homecare management platform that unifies providers, state Medicaid programs, managed care organizations (MCOs), and caregivers into a seamless, secure, and scalable ecosystem. By merging robust technology with decades of industry experience, Care boarding  not only facilitates electronic visit verification (EVV) and ensures regulatory compliance but also revolutionizes the way homecare agencies manage billing, scheduling, payroll, and real-time data reporting.`,
      industry: 'Health Care',
      country: 'USA',
      builtFor: 'SaaS Platform',
      technologies: 'iOS | Android | Laravel | AI | MySQL | Node.JS | Firebase',
      IconComponent: CareboardingIcon,
   },
   // {
   //    href: '/portfolio/case-studies/robotmaker-ai',
   //    title: 'Robot Maker AI',
   //    description: `Robot Maker AI  enters this ecosystem as a platform designed to facilitate the creation, deployment, renting, and subscription of trading robots—colloquially referred to as “bots” or “expert advisors.” By integrating powerful features such as an AI engine for forecasts, real-time data processing through MetaTrader 5, and a user-friendly marketplace built with a modern technology stack (React.js, Node.js, Python, and MySQL), Robot Maker AI  aims to democratize algorithmic trading and bring advanced tools to a broader audience.`,
   //    industry: 'Finance & trading',
   //    country: 'USA',
   //    builtFor: 'SaaS Platform',
   //    technologies:
   //       'Python | Restful API | React JS | Metatrader | AWS | AI | MySQL',
   //    IconComponent: RobotmakerIcon,
   //    reverse: true, // optional, if you want to reverse layout
   // },
]

export default function ProjectShowcase() {
   const [activeSection, setActiveSection] = useState('mobile-application')

   return (
      <>
         <section id="projects-list" className="cs-bg-secondary">
            <div className="">
               <div className="container">
                  <h2 className="section_heading_title mb-3 tech_title">
                     Projects we successfully developed
                  </h2>

                  <p className="section_desc">
                     One look is worth a thousand words.
                  </p>

                  <div className="process-nav d-flex justify-content-center flex-wrap">
                     <button
                        className={`process-nav-btn ${
                           activeSection === 'mobile-application'
                              ? 'active'
                              : ''
                        }`}
                        data-target="mobile-application"
                        onClick={(_) => setActiveSection('mobile-application')}
                     >
                        Mobile Application
                     </button>
                     <button
                        className={`process-nav-btn ${
                           activeSection === 'web-application' ? 'active' : ''
                        }`}
                        data-target="web-application"
                        onClick={(_) => setActiveSection('web-application')}
                     >
                        Web Application
                     </button>
                  </div>
               </div>

               <div>
                  <div
                     className={`process-content-item ${
                        activeSection === 'mobile-application' ? 'active' : ''
                     }`}
                     id="mobile-application"
                  >
                     {mobilePortfolioItems.map((it) => (
                        <PortfolioItem
                           key={`portfolio-item-${it.title}`}
                           imageSrc={it.imageSrc}
                           title={it.title}
                           description={it.description}
                           businessNeeds={it.businessNeeds}
                           learnMoreLink={it.learnMoreLink}
                           imageFirst={it.imageFirst}
                        />
                     ))}
                  </div>
                  <div
                     className={`process-content-item ${
                        activeSection === 'web-application' ? 'active' : ''
                     }`}
                     id="web-application"
                  >
                     <div className="container">
                        <div className="row">
                           <div className="container">
                              {webPortfolioItems.map((it, idx) => (
                                 <WebPortfolioItem
                                    key={`web-portfolio-item-${idx}`}
                                    href={it.href}
                                    title={it.title}
                                    description={it.description}
                                    industry={it.industry}
                                    country={it.country}
                                    builtFor={it.builtFor}
                                    technologies={it.technologies}
                                    IconComponent={it.IconComponent}
                                    reverse={it.reverse}
                                 />
                              ))}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   )
}
